






























import Component from 'vue-class-component'
import Modal from '../../../../../../components/Modal.vue'
import ScrollView from '@/components/ScrollView.vue'
import CollectionSharedFunctions from '@/views/app/management/collections/CollectionSharedFunctions'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import Card from '@/components/Card.vue'
import { ESortOrder } from '@zunta/configurations'

@Component({
  components: { Card, DateTimeLabel, ScrollView, Modal },
  props: {
    resident: {
      required: true
    }
  }
})
export default class ResidentCollectionHistoryModal extends CollectionSharedFunctions {
  isLoading: boolean = false

  async mounted () {
    this.isLoading = true
    await this.fetchResidentHistory(this.$props.resident)
    this.isLoading = false
  }

  destroyed () {
    this.residentModuleInstance.SET_COLLECTION_HISTORY([])
    this.residentModuleInstance.SET_COLLECTION_HISTORY_TOTAL(0)
  }

  async fetchResidentHistory (residentId?: string | number) {
    await this.residentModuleInstance.fetchResidentHistoryByFilters({
      residentId: residentId || this.residentId,
      filters: {
        ...this.residentHistoryFilters,
        sortBy: 'date',
        sortOrder: ESortOrder.DESC
      }
    })
  }
}
